import {Controller} from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["form", "loader"]

    connect() {
        console.log("Form controller connected")
    }

    async submit(event) {
        if (this.formTarget.dataset.remote === 'false') return

        event.preventDefault()
        this.showLoader()

        try {
            const formData = new FormData(this.formTarget)
            const response = await fetch(this.formTarget.action, {
                method: this.formTarget.method,
                body: formData,
                headers: {
                    "Accept": "text/vnd.turbo-stream.html, text/html",
                    "X-CSRF-Token": this.getCSRFToken()
                }
            })

            if (!response.ok) {
                throw new Error('Form submission failed')
            }

            const contentType = response.headers.get("Content-Type")

            if (contentType.includes("text/html")) {
                window.location.href = response.url
            } else {
                const html = await response.text()
                Turbo.renderStreamMessage(html)
            }
        } catch (error) {
            this.displayErrors(['An error occurred. Please try again.'])
        } finally {
            this.hideLoader()
        }
    }

    displayErrors(errors) {
        const errorDiv = document.getElementById('error_messages')
        if (errorDiv) {
            errorDiv.innerHTML = `
        <div class="bg-red-50 p-4 rounded-md">
          <ul class="list-disc pl-5">
            ${errors.map(error => `<li class="text-red-700">${error}</li>`).join('')}
          </ul>
        </div>
      `
        }
    }

    showLoader() {
        this.loaderTarget.classList.remove('hidden')
    }

    hideLoader() {
        this.loaderTarget.classList.add('hidden')
    }

    getCSRFToken() {
        return document.querySelector('[name="csrf-token"]')?.content
    }
}